import * as React from "react"
import { Switch, Route } from "react-router-dom"
import * as routes from "../../util/routes"
import budgetsAnnexes from "../page/budgetsAnnexe/index"
import { LocalAuthorityDashbord, LocalAuthorityDetail } from "../local-authority"
import Services from "../services"
import InstructionList  from "../local-authority/local-authority-detail/instruction-card/instruction-list"
import CustomTrackingRouter from "./custom-tracking-router"
import localAuthorityDashbord from "../local-authority/local-authority-dashbord"

export default class LocalAuthorityRouter extends React.Component {
	render() {
		return (
			<Switch>
				<Route exact path={routes.TDB} component={LocalAuthorityDashbord} />
				<Route exact path={routes.COLLECTIVITE} component={LocalAuthorityDetail} />
				<Route exact path={routes.BUDGETS_ANNEXES} component={budgetsAnnexes} />
				<Route exact path={routes.LOCAL_AUTHORITY_SERVICES_PATTERN} component={Services} />
				<Route exact path={routes.LOCAL_AUTHORITY_INSTRUCTION} component={InstructionList} />
				{/* <Route exact path={routes.LOCAL_AUTHORITY_SERVICE_PATTERN} component={ServiceDetail} /> */}
				<Route path={routes.CUSTOM_TRACKING_PATTERN} component={CustomTrackingRouter}/>
			</Switch>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component/router/local-authority-router.tsx